import {
    applyMiddleware,
    legacy_createStore as createStore,
} from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/logOnlyInProduction';
import logger from 'redux-logger';
import thunk from 'redux-thunk';
import rootReducer from './reducers/index';

const composeEnhancers = composeWithDevTools({
    // options like actionSanitizer, stateSanitizer
});

const configureStore = () => {
    const middleware: any[] = [thunk];

    if (process.env.NODE_ENV !== 'production') {
        middleware.push(logger);
    }

    return createStore(
        rootReducer,
        composeEnhancers(applyMiddleware(...middleware),)
    );
};

export default configureStore;
